import {
  PSMS_DIGITAL_SOLUTION_SUMMARY_FAILURE,
  PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS,
  PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING,
  PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST,
  PSMS_DS_ADOPTIONRATE_REQUEST,
  PSMS_DS_ADOPTIONRATE_SUCCESS,
  PSMS_DS_ADOPTIONRATE_FAILURE,
  PSMS_DS_ADOPTIONRATE_LOADING,
} from '../../../actions/actionTypes';

interface PaymentIntegrityState {
  adoptionRate: any;
  isLoading: boolean;
  ediData: any;
  isLoadigAdoptionRate: boolean;
  error: any;
}

const initialState: PaymentIntegrityState = {
  adoptionRate: null,
  isLoading: false,
  ediData: null,
  isLoadigAdoptionRate: false,
  error: null,
};

const DigitalAdoptionReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityState => {
  switch (action.type) {
    case PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST:
      return {
        ...state,
        isLoading: true,
        ediData: 0,
        error: null,
      };
    case PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS:
      return {
        ...state,
        ediData: action.payload,
      };
    case PSMS_DIGITAL_SOLUTION_SUMMARY_FAILURE:
      return {
        ...state,
        isLoading: false,
        ediData: 0,
        error: action.payload,
      };
    case PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case PSMS_DS_ADOPTIONRATE_REQUEST:
      return {
        ...state,
        isLoadigAdoptionRate: true,
        adoptionRate: 0,
        error: null,
      };
    case PSMS_DS_ADOPTIONRATE_SUCCESS:
      return {
        ...state,
        adoptionRate: action.payload,
      };
    case PSMS_DS_ADOPTIONRATE_FAILURE:
      return {
        ...state,
        isLoadigAdoptionRate: false,
        adoptionRate: 0,
        error: action.payload,
      };
    case PSMS_DS_ADOPTIONRATE_LOADING:
      return {
        ...state,
        isLoadigAdoptionRate: action.payload,
      };
    default:
      return state;
  }
};

export default DigitalAdoptionReducer;
